import { graphql, useStaticQuery } from 'gatsby';

// static query for navlist of prisons series - no image needed
const useAbandonedPrisons = () => {
  const data = useStaticQuery(graphql`
    query {
      allMdx(
        filter: { frontmatter: { series: { eq: "Abandoned Prisons" } } }
        sort: { fields: [frontmatter___name], order: ASC }
      ) {
        nodes {
          frontmatter {
            name
            slug
            title
            series
            media
            size
            year
            city
            state
            country
          }
        }
      }
    }
  `);

  return data.allMdx.nodes;
};

export default useAbandonedPrisons;
